<template>
<v-form ref="form" v-model="form.valid">
    <v-row justify="center" style="margin-top: 30px">
        <v-col cols="12" md="6" lg="6" sm="12">
            <div class="declaration-text">
                <b>Parent Declaration *</b><br><br>
            </div>
            <div class="declaration-text">
                I {{this.reference.FirstName}} {{this.reference.LastName}} confirm that I am the parent or legal guardian of {{this.reference['GO_Scholar__c.Name']}} who is applying for a GO Scholarship at {{this.reference.School__c}}. <br><br>
            </div>
            <div class="declaration-text">
                I agree and acknowledge the terms of the <a href="https://gofoundation.org.au/privacy/" target="_blank" style="color: #ea7f1d">Privacy Policy and Collection Statement</a>.  In the event that a GO scholarship is awarded on the basis of this application form and any subsequent interviews and enquiries, I agree to the following:<br><br>
            </div>
            <!--   High public and High Independent    v-if="!IsPrimary"  -->
            <div class="declaration-text" v-if="!IsPrimary">
                <b>1.</b>&emsp;The student will:<br><br>
                <div style="padding-left: 20px">
                    <b>a.</b>&emsp;Participate to the best of their ability at school and will work hard at learning and making the most of academic and other opportunities the school offers them;<br><br>
                    <b>b.</b>&emsp;Work with the CareerTrackers Student Advisor that GO provides them in Year 12 to discuss their university options after Year 12;<br><br>
                    <b>c.</b>&emsp;In the event that they wish to pursue a different education path after Year 12, work with the GO Student Advisor to discuss options available;<br><br>
                    <b>d.</b>&emsp;Advise the GO Foundation after their Year 12 exam results are released as to what they have chosen to do in terms of work and education;<br><br>
                    <b>e.</b>&emsp;Use best endeavours to attend GO Mentoring and other events and we understand that not attending these events may put the student's scholarship at risk;<br><br>
                    <b>f.</b>&emsp;Maintain regular contact with GO and keep our contact details current.<br><br> 
                </div>
                <b>2.</b>&emsp;For the GO Foundation to receive copies of my child’s school reports, NAPLAN results and other similar information relating to their academic and extra-curricular activities from the school;<br><br>
                <b>3.</b>&emsp;For the GO Foundation to provide any and all of the above information (including contact details) to CareerTrackers as part of their activities with the GO Ecosystem and in connection with their activities with GO students;<br><br>
                <b>4.</b>&emsp;For the school at which the GO Scholarship is provided, to be authorised to sign any other consents or undertakings on my behalf in relation to activities or events my child/the student may participate in; and<br><br>
                <b>5.</b>&emsp;Subject to any applicable terms of the <a href="https://gofoundation.org.au/privacy/" target="_blank" style="color: #ea7f1d">Privacy Policy and Collection Statement</a>, the GO Foundation disclosing/publishing information relating to my child/the student, including any photos or video footage of my child/student at GO activities or events, at the school or in relation to the GO Scholarship. This consent extends to the use of such information, photos and video by GO Ecosystem partners.<br><br>
                <!--  div v-if="showindependentquestion()&&!IsPrimary" -->
                    <!--  b>6.</b>&emsp;I will:<br><br  -->
                    <!--  div style="padding-left: 20px" -->
                        <!--  b>a.</b>&emsp;Make a parent contribution to the school of {{ this.reference.Contribute_To_Education__c }} weekly/ {{ this.reference.Contribute_To_Education__c * 52 }} annually towards my child’s educational expenses<br><br  -->
                        <!--  b>a.</b>&emsp;Inform the school and the GO Foundation if my financial circumstances change and I need to adjust the amount towards my parental contribution. <br><br  -->
                        <!--  b>b.</b>&emsp;Setup and maintain financial arrangements to make the agreed parental contribution to the school (eg: direct debit, centrepay)<br><br   -->
                    <!--  /div  -->
                <!--  /div -->               
                <div class="declaration-text" :value="reference.Guardian_Parents_Declaration_Signed__c"><b>Please check "I agree" below to show your acknowledgement and agreement with the terms above.</b></div>
            </div>
            <!--   End  -->

            <!--   Primary  School Scholarship    v-if="!IsPrimary"  -->
            <div class="declaration-text" v-if="IsPrimary">
                <b>1.</b>&emsp;The student will:<br><br>
                <div style="padding-left: 20px">
                    <b>a.</b>&emsp;Participate to the best of their ability at school and will work hard at learning and making the most of academic and other opportunities the school offers them;<br><br>
                    <b>b.</b>&emsp;Use best endeavours to attend GO Mentoring and other events and we understand that not attending these events may put the student's scholarship at risk;<br><br>
                    <b>c.</b>&emsp;Maintain regular contact with GO and keep our contact details current;<br><br>
                </div>
                <b>2.</b>&emsp;For the GO Foundation to receive copies of my child’s school reports, NAPLAN results and other similar information relating to their academic and extra-curricular activities from the school;<br><br>
                
                <b>3.</b>&emsp;For the school at which the GO Scholarship is provided, to be authorised to sign any other consents or undertakings on my behalf in relation to activities or events my child/the student may participate in; and<br><br>
                <b>4.</b>&emsp;Subject to any applicable terms of the <a href="https://gofoundation.org.au/privacy/" target="_blank" style="color: #ea7f1d">Privacy Policy and Collection Statement</a>, the GO Foundation disclosing/publishing information relating to my child/the student, including any photos or video footage of my child/student at GO activities or events, at the school or in relation to the GO Scholarship. This consent extends to the use of such information, photos and video by GO Ecosystem partners.<br><br>            
                <div class="declaration-text" :value="reference.Guardian_Parents_Declaration_Signed__c"><b>Please check "I agree" below to show your acknowledgement and agreement with the terms above.</b></div>
            </div>
            <!--   End 1 -->
            <!--   Old  -->
            <!-- div class="declaration-text">
                <b>1.</b>&emsp;The student will:<br><br>
                <div style="padding-left: 20px" v-if="!IsPrimary">
                    <b>a.</b>&emsp;Participate to the best of their ability at school and will work hard at learning and making the most of academic and other opportunities the school offers them;<br><br>
                    <b>b.</b>&emsp;Work with the CareerTrackers Student Advisor that GO provides them in Year 12 to discuss their university options after Year 12;<br><br>
                    <b>c.</b>&emsp;In the event that they wish to pursue a different education path after Year 12, work with the GO Student Advisor to discuss options available;<br><br>
                    <b>d.</b>&emsp;Advise the GO Foundation after their Year 12 exam results are released as to what they have chosen to do in terms of work and education;<br><br>
                    <b>e.</b>&emsp;Use best endeavours to attend GO Mentoring and other events and we understand that not attending these events may put the student's scholarship at risk;<br><br>
                    <b>f.</b>&emsp;Maintain regular contact with GO and keep our contact details current.<br><br> 
                </div>
                <div style="padding-left: 20px" v-if="IsPrimary">
                    <b>a.</b>&emsp;Participate to the best of their ability at school and will work hard at learning and making the most of academic and other opportunities the school offers them;<br><br>
                    <b>b.</b>&emsp;Use best endeavours to attend GO Mentoring and other events and we understand that not attending these events may put the student's scholarship at risk;<br><br>
                    <b>c.</b>&emsp;Maintain regular contact with GO and keep our contact details current;<br><br>
                </div>
                <b>2.</b>&emsp;For the GO Foundation to receive copies of my child’s school reports, NAPLAN results and other similar information relating to their academic and extra-curricular activities from the school;<br><br>
                <b>3.</b>&emsp;For the GO Foundation to provide any and all of the above information (including contact details) to CareerTrackers as part of their activities with the GO Ecosystem and in connection with their activities with GO students;<br><br>
                <b>4.</b>&emsp;For the school at which the GO Scholarship is provided, to be authorised to sign any other consents or undertakings on my behalf in relation to activities or events my child/the student may participate in; and<br><br>
                <b>5.</b>&emsp;Subject to any applicable terms of the <a href="https://gofoundation.org.au/privacy/" target="_blank" style="color: #ea7f1d">Privacy Policy and Collection Statement</a>, the GO Foundation disclosing/publishing information relating to my child/the student, including any photos or video footage of my child/student at GO activities or events, at the school or in relation to the GO Scholarship. This consent extends to the use of such information, photos and video by GO Ecosystem partners.<br><br>
                <div v-if="showindependentquestion()&&!IsPrimary">
                    <b>6.</b>&emsp;I will:<br><br>
                    <div style="padding-left: 20px">
                        <b>a.</b>&emsp;Make a parent contribution to the school of {{ this.reference.Contribute_To_Education__c }} weekly/ {{ this.reference.Contribute_To_Education__c * 52 }} annually towards my child’s educational expenses<br><br>
                        <b>b.</b>&emsp;Inform the school and the GO Foundation if my financial circumstances change and I need to adjust the amount towards my parental contribution. <br><br>
                        <b>c.</b>&emsp;Setup and maintain financial arrangements to make the agreed parental contribution to the school (eg: direct debit, centrepay)<br><br>
                    </div>
                </div>               
                <div class="declaration-text" :value="reference.Guardian_Parents_Declaration_Signed__c"><b>Please check "I agree" below to show your acknowledgement and agreement with the terms above.</b></div>
            </div   -->
            <!--   End Old  -->

            <div>
                <v-checkbox class="declaration-text" color="#ea7f1d" v-model="reference.Guardian_Parents_Declaration_Signed__c" :rules="[v=>!!v]" label="I agree with the terms above *"></v-checkbox>
            </div>
            <div>
                <v-checkbox class="declaration-text" color="#ea7f1d" v-model="reference.Child_in_Care__c"  label="If your child is in care please tick this box so their photos won't be published on our website"></v-checkbox>
            </div>
            <!-- <div class="signature">
                <canvas width="600" height="140" id="signature" class="pad" @mouseup="storeSignature"></canvas>
                <div class="name"  disabled="true">{{this.reference.FirstName}} {{this.reference.LastName}}</div>
                <div class="clear-signature" @click="clearSignature"><span>Clear signature</span></div>
            </div>  -->
        </v-col>
    </v-row>
</v-form>
</template>
<script>
import SignaturePad from 'signature_pad'
export default {
    data: function() {
        return {
            school_type: '',
            IsPrimary: false,

            
        }
    },
    async beforeMount() {
        this.school_type = this.$store.getters['schtype/getschtype']['scholarshiptype'];
        console.log('school type in declar' + this.school_type);
        if(this.$store.getters['schtype/getschtype']['schooltype'] == 'primary'){
            this.IsPrimary = true;
        }
        
    },
    mounted() {
        const canvas = document.getElementById('signature');
        this.signaturePad = new SignaturePad(canvas);
    },
    beforeDestroy() {
        this.signaturePad && this.signaturePad.off();
    }, 
    computed: { 
        reference(){
            return this.$parent.reference
        },
        form() {
            return this.$parent.form
        }
        
    },  
    methods: {
        storeSignature() {
            this.signature = this.signaturePad.toData()
            this.reference.Guardian_Parents_Declaration_Signed__c = this.signature.length > 0
        }, 
        clearSignature() {
            this.signaturePad.clear();
            this.storeSignature();
        },
        showindependentquestion() {
            this.school_type = this.$store.getters['schtype/getschtype']['scholarshiptype'];
            //console.log('school type in declar' + this.school_type);
            if(this.school_type.toLowerCase() == 'independent'){
                return true;
            }else{
                return false;
            }
        }
     }
    
}
</script>
<style lang="scss" scoped>
.declaration-text {
    font-family: Hind;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    color: var(--declaration-text-color);
}

.signature {
    margin-bottom: 10px;
    margin-top: 20px;
    text-align: center;
    height: 210px;
    >.pad {
        border: solid 2px #979797;
        background-color: #ffffff;
    }
    >.name {
        width: 40%;
        margin: auto;
        font-family: Hind;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.44;
        letter-spacing: normal;
        text-align: center;
        color: black;
        position: relative;
        padding-top: 5px;
    }
}
.clear-signature {
    direction: rtl;
    font-family: $secondary-font;
    margin-bottom: 40px;
    >span {
        font-size: 14px;
        line-height: 1.43;
        color: #ea7f1d;
        text-decoration: underline;
        cursor: pointer;
    }
}
.declaration {
    margin-bottom: 30px;
    font-family: $secondary-font;
}

</style>